import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App';
import './index.css';

console.log('AGP: Iniciando aplicación...');
console.log('AGP: Hostname:', window.location.hostname);
console.log('AGP: UserAgent:', navigator.userAgent);
console.log('AGP: Protocol:', window.location.protocol);

const rootElement = document.getElementById('root');
if (!rootElement) {
  console.error('AGP: No se encontró el elemento #root');
  const errorDiv = document.createElement('div');
  errorDiv.style.cssText = 'position:fixed;top:0;left:0;width:100%;background:red;color:white;padding:20px;z-index:9999;';
  errorDiv.innerText = 'CRITICAL ERROR: No se encontró el elemento #root en el DOM.';
  document.body.appendChild(errorDiv);
} else {
  console.log('AGP: Renderizando aplicación...');
  try {
    const root = createRoot(rootElement);
    root.render(
      <StrictMode>
        <App />
      </StrictMode>,
    );
    console.log('AGP: Llamada a render completada.');
    
    // Pequeño indicador visual de que el JS se ha ejecutado
    const debugTag = document.createElement('div');
    debugTag.style.cssText = 'position:fixed;bottom:5px;right:5px;font-size:8px;color:#ccc;z-index:9999;pointer-events:none;';
    debugTag.innerText = 'JS OK';
    document.body.appendChild(debugTag);
  } catch (error) {
    console.error('AGP: Error durante el renderizado inicial:', error);
    const errorDiv = document.createElement('div');
    errorDiv.style.cssText = 'position:fixed;top:0;left:0;width:100%;background:red;color:white;padding:20px;z-index:9999;';
    errorDiv.innerText = 'RENDER ERROR: ' + (error instanceof Error ? error.message : String(error));
    document.body.appendChild(errorDiv);
  }
}
